
















import ReviewListFilterFlow from '@/components/ReviewListFilterFlow.vue'
import EstablishmentList from '@/components/EstablishmentList.vue'
import FlowDetail from '@/components/FlowDetail.vue'
import utils from '@/utils.coffee'

export default {
    "name": "flow",
    "components": {
        ReviewListFilterFlow
        FlowDetail
    }
    "data": ()->
        self = this
        return {
            showPad: false
        }
    "methods":
        "togglePad": (newShowPad) ->
            @showPad = newShowPad
}
